<template>
  <div class="passengers-info-warp">
    <div class="passengers-info">
      <div v-if="index===0 && tipShow" class="info-tip-box">
        <div class="info-tip">
          <img src="https://resource.rcclchina.com.cn/tui2/info/tip.png"/>
          <div>至少添加<em class="fc-red">1</em>位乘客生成订单</div>
        </div>
        <div class="info-tip">
          <img src="https://resource.rcclchina.com.cn/tui2/info/tip.png"/>
          <div>该乘客请勿重复添加，提交后不可修改</div>
        </div>
      </div>
      <div class="base-info" :class="{'is-bc-no': !tipShow}">
        <div class="base-info-top">
          <span class="passenger-title">乘客{{index+1}}</span>
          <RcclCheckBox
              :title="'添加为常用乘客'"
              :defaultChecked="true"
          />
          <span class="claer-lable" @click="clearGuest">清空</span>
        </div>
        <div class="base-info-top guest-nationality">
          <label for="zhFirstName">国家或地区： </label>
          <select class="css_nationality js_nationality" v-model="nationality">
            <option v-for="(country, i) in countries" :key="('country_'+i)"
                    :value="country.countryCode">{{country.countryName}}</option>
          </select>
        </div>
        <div class="passengers-form-left">
          <div class="passenger-name input-warp">
            <label class="is-required">中文姓 </label>
            <input type="text" class="guestLastName"
                   :placeholder="(isCN ? '必须与护照一致': '选填')" v-model="lastName"
                   @change="onNameChanged('lastName')" @focus="showSelectContact($event)">
          </div>
          <div class="passenger-name input-warp">
            <label class="is-required">拼音姓 </label>
            <input type="text" class="guestPYLastName guestFormInput"
                   :placeholder="(isCN ? '必须与护照一致': '必填 last name')"
                   v-model="pyLastName" @change="onGuestInfoChanged">
          </div>
          <div class="passenger-name input-warp">
            <label class="is-required">性别</label>
            <RcclRadio
                :options="genderOptions"
                v-on:onChanged="genderChanged"
                class="genderRadio"/>
          </div>
          <div class="passenger-name input-warp">
            <label for="fold-more-info">手机号 </label>
            <div class="dropdown callingCode" data-value="+86">
              <button class="btn btn-default dropdown-toggle" type="button" data-toggle="dropdown"
                      aria-haspopup="true" aria-expanded="false">
                <span class="callingcode-name">{{`${selectedCallingCode.countryName}(${selectedCallingCode.callingCode})`}}</span>
                <span class="caret"></span>
              </button>
              <ul class="dropdown-menu" aria-labelledby="callingCodeDropDown">
                <li v-for="(code, i) in callingCodes" :key="('callingCode_' + i)">
                  <a @click="callingCodeChanged(code.callingCode)">{{`${code.countryName}(${code.callingCode})`}}</a>
                </li>
              </ul>
            </div>
            <input type="text" class="guestMobile guestFormInput" v-model="telephone"  placeholder="请输入手机号"
                   @change="onGuestInfoChanged" @blur="verifyTelephone" style="width: 190px">
            <div v-if="telephoneError" class="telephone-error">手机号格式不正确</div>
          </div>
          <div class="passenger-name input-warp">
            <label for="passport">护照号 </label>
            <input type="text" class="guestPassport guestFormInput" v-model="passport" placeholder="请输入护照号码"
                   @change="onGuestInfoChanged">
          </div>
        </div>
        <div class="passengers-form-right">
          <div class="passenger-name input-warp input-warp">
            <label class="zh-last-name is-required">中文名 </label>
            <input type="text" class="guestFirstName"
                   :placeholder="(isCN ? '必须与护照一致': '选填')"  v-model="firstName"
                   @change="onNameChanged('firstName')" @focus="showSelectContact($event)">
          </div>
          <div class="passenger-name input-warp">
            <label  class="zh-last-name is-required">拼音名 </label>
            <input type="text" class="guestPYFirstName guestFormInput"
                   :placeholder="(isCN ? '必须与护照一致': '必填 first name')"
                   v-model="pyFirstName" @change="onGuestInfoChanged">
          </div>
          <div class="passenger-name input-warp">
            <label for="birthday" class="zh-last-name is-required">出生日期 </label>
            <input type="text" placeholder="请选择出生日期" class="birthday guestBirthday guestFormInput" :value="birthDate"
                   name="DateOfBirth" @focus="showBirthdayCalendar($event)">
            <RcclCalendar
                class="guestInfo-calender"
                v-if="isBirthDayCalendarShow"
                :allowPreYear="true"
                :defaultDate="birthDate"
                v-on:onDateClicked="birthDateChanged"
            />
            <img @click="showBirthdayCalendar($event)" src="https://resource.rcclchina.com.cn/tui2/info/calandar.png" class="calandar-icon"
                 alt="">
            <!-- <img src="https://resource.rcclchina.com.cn/tui2/info/children.png" class="children-icon" alt=""> -->
          </div>
          <div class="passenger-name input-warp">
            <label for="passengerEmail" class="zh-last-name">Email</label>
            <input type="text" class="guestEmail guestFormInput" v-model="email" placeholder="请输入电子邮箱"
                   @change="onGuestInfoChanged">
          </div>
          <div class="passenger-name input-warp">
            <label for="unOverdue passport" class="zh-last-name">有效期 </label>
            <input type="text" class="guestPassportExpireIn guestPassport guestFormInput" :value="passportExpiresIn"
                   name="Passport" placeholder="请输入护照有效期" @focus="showPassportCalendar($event)">
            <RcclCalendar
                class="guestInfo-calender"
                v-if="isPassportCalendarShow"
                :allowPreYear="false"
                :defaultDate="passportExpiresIn"
                v-on:onDateClicked="passportExpiresInChanged"
            />
          </div>
        </div>
      </div>
      <!--            <div class="more-info-tip" :class="{ active: isMoreOpen}" @click="isMoreOpen=!isMoreOpen">-->
      <!--                <span class="fold-more-info comment-css"><span-->
      <!--                        style="">展开更多信息（选填）</span><img-->
      <!--                        src="https://resource.rcclchina.com.cn/tui2/list/icon-down.png" alt=""></span>-->
      <!--                <span class="show-more-info comment-css"><span>收起更多信息（选填）</span><img-->
      <!--                        src="https://resource.rcclchina.com.cn/tui2/list/icon-up.png" alt=""></span>-->
      <!--            </div>-->
      <!--            <div class="more-info-warp active">-->
      <!--                <div class="">-->
      <!--                    <div class="passenger-name input-warp input-warp-left">-->
      <!--                        <label for="passport">护照号 </label>-->
      <!--                        <input type="text" class="guestPassport guestFormInput" v-model="passport" placeholder="请输入护照号码"-->
      <!--                        @change="onGuestInfoChanged">-->
      <!--                    </div>-->
      <!--                    <div class="passenger-name input-warp input-warp-right">-->
      <!--                        <label for="unOverdue passport" class="zh-last-name">有效期 </label>-->
      <!--                        <input type="text" class="guestPassportExpireIn guestPassport guestFormInput" :value="passportExpiresIn"-->
      <!--                            name="Passport" placeholder="请输入护照有效期" @focus="showPassportCalendar($event)">-->

      <!--                        <RcclCalendar -->
      <!--                            class="guestInfo-calender"-->
      <!--                            v-if="isPassportCalendarShow"-->
      <!--                            :allowPreYear="false"-->
      <!--                            :defaultDate="passportExpiresIn"-->
      <!--                            v-on:onDateClicked="passportExpiresInChanged"-->
      <!--                        />-->
      <!--                    </div>-->
      <!--                </div>-->
      <!--                <div class="">-->
      <!--                    <div class="passenger-name input-warp input-warp-left">-->
      <!--                        <label for="fold-more-info">手机号 </label>-->
      <!--                        <div class="dropdown callingCode" data-value="+86">-->
      <!--                            <button class="btn btn-default dropdown-toggle" type="button" data-toggle="dropdown"-->
      <!--                                aria-haspopup="true" aria-expanded="false">-->
      <!--                                <span class="callingcode-name">{{`${selectedCallingCode.countryName}(${selectedCallingCode.callingCode})`}}</span>-->
      <!--                                <span class="caret"></span>-->
      <!--                            </button>-->
      <!--                            <ul class="dropdown-menu" aria-labelledby="callingCodeDropDown">-->
      <!--                                <li v-for="(code, i) in callingCodes" :key="('callingCode_' + i)">-->
      <!--                                    <a @click="callingCodeChanged(code.callingCode)">{{`${code.countryName}(${code.callingCode})`}}</a>-->
      <!--                                </li>-->
      <!--                            </ul>-->
      <!--                        </div>-->
      <!--                        <input type="text" class="guestMobile guestFormInput" v-model="telephone"  placeholder="请输入手机号"-->
      <!--                        @change="onGuestInfoChanged">-->
      <!--                    </div>-->
      <!--                    <div class="passenger-name input-warp input-warp-right">-->
      <!--                        <label for="passengerEmail" class="zh-last-name">Email</label>-->
      <!--                        <input type="text" class="guestEmail guestFormInput" v-model="email" placeholder="请输入电子邮箱"-->
      <!--                        @change="onGuestInfoChanged">-->
      <!--                    </div>-->
      <!--                </div>-->
      <!--            </div>-->
    </div>
    <div class="children-warp" style="display:none">
      <div>
        <div>
          <div style="color:#282b2c">
            <span>儿童未满8周岁，可使用</span>
            <span style="color:#0073bb">
                            儿童陆地入住酒店不占床优惠
                            <img src="https://resource.rcclchina.com.cn/tui2/info/webhao.png" class="wenhao" alt="">
                        </span>
          </div>
          <div style="color:#747d80;font-size: 12px;">(三人房最多可勾选1名儿童)</div>
        </div>
      </div>
      <div>
        <label class="checkBox"><input type="checkbox" checked="true"><span></span></label>
        <label class="checkBox"><input type="checkbox"><span></span></label>
      </div>
    </div>
  </div>
</template>

<script>
import bookingHelper from '@/utilities/bookingHelper'
import api from '@/api'
import {checkTel} from "@/utilities/tools";
const RcclCheckBox = () => import('@/components/Common/RcclCheckBox')
const RcclRadio = () => import('@/components/Common/RcclRadio')
const RcclCalendar = () => import('@/components/Common/RcclCalendar')

export default {
  name: "GuestInfoGuest",
  components: {
    RcclCheckBox,
    RcclRadio,
    RcclCalendar
  },
  props: {
    guest: {
      type: Object
    },
    nowTime: {
      type: Number
    },
    index: {
      type: Number
    },
    tipShow: {
      type: Boolean,
      default: true
    },
    onGuestConfirm: {
      type: Function
    },
    onSelectContactShow: {
      type: Function
    }
  },
  data () {
    return {
      nationality: 'CN',
      lastName: '',
      firstName: '',
      pyLastName: '',
      pyFirstName: '',
      name: '',
      birthDate: '',
      passport: '',
      passportExpiresIn: '',
      gender: '',
      telephone: '',
      telephoneError: false,
      email: '',
      callingCode: '86',
      id: -1,
      isMoreOpen: false,
      isBirthDayCalendarShow: false,
      isPassportCalendarShow: false
    }
  },
  beforeMount () {
    this.initGuest()
  },
  beforeDestroy () {
    this.clearGuest()
  },
  methods: {
    initGuest () {
      this.nationality = this.guest.nationality || 'CN'
      if (this.guest.lastName && this.guest.lastName.length > 0) {
        this.lastName = this.guest.lastName
      }
      if (this.guest.firstName&&this.guest.firstName.length > 0) {
        this.firstName = this.guest.firstName
      }
      if (this.guest.pyLastName && this.guest.pyLastName.length > 0) {
        this.pyLastName = this.guest.pyLastName
      }
      if (this.guest.pyFirstName && this.guest.pyFirstName.length > 0) {
        this.pyFirstName = this.guest.pyFirstName
      }
      if (this.guest.birthDate && this.guest.birthDate.length > 0) {
        this.birthDate = this.guest.birthDate
      }
      if (this.guest.gender && this.guest.gender.length > 0) {
        this.gender = this.guest.gender
      }

      this.passport = this.guest.passport
      this.passportExpiresIn = this.guest.passportExpiresIn
      this.telephone = this.guest.telephone
      this.email = this.guest.email
      this.callingCode = this.guest.callingCode || '86'
      this.id = this.guest.id == 0 ? 0 :this.guest.id || -1
      this.verifyTelephone()
    },
    callingCodeChanged (value) {
      let code = value + ''
      if (code && code.length > 0) {
        this.callingCode = code.replace('+', '')
      }
      this.verifyTelephone();
      this.onGuestInfoChanged();
    },
    genderChanged (value) {
      this.gender = value
      this.onGuestInfoChanged()
    },
    showBirthdayCalendar(e) {
      e.preventDefault()
      e.target.blur()
      this.isBirthDayCalendarShow = !this.isBirthDayCalendarShow
    },
    birthDateChanged (value) {
      if (value && value.length > 0) {
        this.birthDate = value
      }
      this.onGuestInfoChanged()
      this.isBirthDayCalendarShow = false
    },
    showPassportCalendar (e) {
      e.preventDefault()
      e.target.blur()
      this.isPassportCalendarShow = !this.isPassportCalendarShow
    },
    passportExpiresInChanged (value) {
      if (value && value.length > 0) {
        this.passportExpiresIn = value
      }
      this.onGuestInfoChanged()
      this.isPassportCalendarShow = false
    },
    async onNameChanged(key) {
      let value = ''
      if (key == "firstName") {
        value = this.firstName
      } else if (key == 'lastName') {
        value = this.lastName
      }
      if (value.length > 0) {
        await this.getPinyin(key, value)
        this.onGuestInfoChanged()
      }
    },
    onGuestInfoChanged () {
      // 检查必填项是否填完整，填完整的话调用接口临时保存
      const guest = {
        nationality: this.nationality,
        lastName: this.lastName,
        firstName: this.firstName,
        pyLastName: this.pyLastName,
        pyFirstName: this.pyFirstName,
        name: this.getGuestName(),
        birthDate: this.birthDate,
        passport: this.passport,
        passportExpiresIn: this.passportExpiresIn,
        gender: this.gender,
        telephone: this.telephone,
        email: this.email,
        callingCode: this.callingCode,
        id: this.id,
      }
      if (bookingHelper.checkGuestConfirm(guest)) {
        this.onGuestConfirm(guest, this.index)
      }
    },
    getGuestName () {
      let name = this.lastName + this.firstName
      if (!name || name.trim().length == 0) {
        name = `${this.pyLastName} ${this.pyFirstName}`
      }
      return name
    },
    async getPinyin (key, value) {
      if (!value || value.length == 0) return
      const { data } = await api.page.getPinyin(value)
      if (data && data.length > 0) {
        if (key == 'firstName') {
          this.pyFirstName = data
        } else if (key == 'lastName') {
          this.pyLastName = data
        }
      }
    },
    showSelectContact (e) {
      this.onSelectContactShow(e, this.index)
    },
    clearGuest () {
      this.nationality ='CN'
      this.lastName = ''
      this.firstName = ''
      this.pyLastName = ''
      this.pyFirstName = ''
      this.birthDate = ''
      this.passport = ''
      this.passportExpiresIn = ''
      this.gender = ''
      this.telephone = ''
      this.email = ''
      this.callingCode = '86'
      this.id = -1
      this.$emit('clearGuest', this.guest);
    },
    verifyTelephone() {
      if(this.callingCode === '86') {
        if(this.telephone && this.telephone.length > 0) {
          this.telephoneError = !checkTel(this.telephone);
        }
      } else {
        this.telephoneError = false;
      }
    }
  },
  computed: {
    genderOptions() {
      let options = [{
        name: "男",
        value: 'M',
        isSelected: this.gender == 'M'
      },{
        name: "女",
        value: 'F',
        isSelected: this.gender == 'F'
      }]
      return options
    },
    countries () {
      if (!this.$store.state.page.countries || this.$store.state.page.countries.length == 0) {
        return []
      }
      return this.$store.state.page.countries.filter(r=>r.countryName && r.countryName.length > 0 && r.countryCode && r.countryCode.length > 0)
    },
    callingCodes () {
      return this.countries.filter(r=>r.callingCode && r.callingCode.length > 0 && r.isAllowSendSms)
    },
    selectedCallingCode () {
      let selectCallingCode = this.callingCode + ''
      if (!this.callingCode || this.callingCode.length == 0) {
        selectCallingCode = "86"
      }

      if (this.callingCode.indexOf('+') < 0) {
        selectCallingCode = "+"+selectCallingCode
      }
      return this.callingCodes.find(r=>r.callingCode == selectCallingCode) || {}
    },
    isCN () {
      return this.nationality == 'CN'
    }
  },
  watch: {
    guest() {
      this.initGuest()
    },
    nowTime(val) {
      if(val) this.initGuest()
    }
  }
}
</script>

<style lang="less" scoped>
.passengers-info-warp {
  padding: 10px;
  padding-left: 0;
  position: relative;
  & .info-tip-box {
    position: absolute;
    top: 13px;
    right: 0;
    & .info-tip {
      display: flex;
      align-items: center;
      font-size: 12px;
      & + .info-tip {
        margin-top: 5px;
      }
      & img {
        height: 16px;
        width: 16px;
      }
      & div {
        margin-left: 5px;
        line-height: 16px;
        & > em {
          font-style: normal;
        }
      }
    }
  }
  .base-info {
    padding-left: 20px;
    border-left: 3px solid #fbc500;
    border-radius: 2px;
    &.is-bc-no {
      border: none;
      padding-left: 0;
      border-radius: 0;
    }
    .base-info-top {
      margin-left: 5px;
    }
  }
  .guest-nationality {
    margin-top: 10px;
    .css_nationality {
      border: none;
      border-bottom: solid 1px #d3dadd;
      vertical-align: -2px;
      font-style: normal;
      padding-left: 10px;
      -webkit-appearance: none;
      background: url(https://resource.rcclchina.com.cn/tui2/list/icon-down.png) 105px center no-repeat;
      background-size: 12px;
    }
  }
  .input-warp {
    position: relative;
  }
  label {
    color: #747d80;
    letter-spacing: 1px;
    font-weight: 400;
  }
  .input-lable {
    width: 60px;
    &.sms {
      width: 85px;
    }
  }
  input {
    border: none;
    border-bottom: solid 1px #d3dadd;
    vertical-align: -2px;
    font-style: normal;
    padding-left: 10px;
  }
  input::-webkit-input-placeholder {
    font-family: MicrosoftYaHei;
    /* font-style: normal; */
    font-size: 14px;
    letter-spacing: 1px;
    color: #919b9f;
    padding-bottom: 10px;
  }
  select {
    border: 0;
    appearance: none;
    -moz-appearance: none;
    -webkit-appearance: none;
    background: url(https://resource.rcclchina.com.cn/tui2/list/icon-down.png)
    230px center no-repeat;
    background-size: 12px;
  }
  input[type="text"] {
    width: 284px;
  }

  .claer-lable {
    color: #006ab9;
    cursor: pointer;
    margin-left: 5px;
    vertical-align: middle;
  }
  .callingCode {
    display: inline-block;
    .btn {
      padding: 1px 0 1px 10px;
      border: none;
      border-bottom: solid 1px #d3dadd;
      background-color: white;
      vertical-align: -2px;
      font-style: normal;
      margin-right: 5px;
      border-radius: 0;
      .caret {
        margin-left: 5px;
      }
    }
    ul {
      max-height: 300px;
      overflow-y: scroll;
      a {
        cursor: pointer;
      }
    }
  }
  .passenger-title {
    font-size: 16px;
    letter-spacing: 1px;
    color: #282b2c;
    vertical-align: middle;
    margin-right: 5px;
  }
  .passengers-form-left, .passengers-form-right {
    display: inline-block;
  }
  .passenger-name {
    margin-top: 20px;
    label {
      width: 70px;
      text-align: right;
      &.is-required:before {
        content: "*";
        color: #ff0000;
      }
    }
    &.input-warp-left {
      label {
        width: 66px;
        margin-right: 10px;
        &.is-required:before {
          content: "*";
          color: #ff0000;
        }
      }
    }
    & .telephone-error {
      position: absolute;
      top: 25px;
      left: 175px;
      font-size: 12px;
      color:#ff0000
    }
  }
  .passengers-form-left .passenger-name label {
    width: 66px;
    text-align: right;
    margin-right: 10px;
  }
  .zh-last-name {
    margin-left: 20px;
    margin-right: 10px;
  }

  .calandar-icon {
    width: 20px;
    height: 20px;
    position: absolute;
    bottom: 6px;
    right: 0;
    margin-right: 5px;
  }
  .genderRadio {
    display: inline-block;
  }
  .more-info-tip {
    width: 704px;
    height: 22px;
    line-height: 22px;
    background-color: #f3f6f8;
    border-radius: 12px;
    text-align: center;
    margin-top: 20px;
    margin-left: 28px;
    cursor: pointer;
    .fold-more-info {
      display: block;
    }
    .show-more-info {
      display: none;
    }
    .comment-css {
      color: #747d80;
      font-size: 12px;
    }
  }

  .more-info-tip.active {
    .fold-more-info {
      display: none;
    }
    .show-more-info {
      display: block;
    }
  }

  .more-info-warp {
    display: none;
    margin-left: 3px;
    padding-left: 20px;
    .input-warp {
      display: inline-block;
    }
    .guestMobile {
      width: 188px;
    }
  }
  .more-info-warp.active {
    display: block;
  }

  .dropdown-menu a {
    cursor: pointer;
  }

  .guestInfo-calender {
    left: 80px;
    top: 10px;
    z-index: 2;
  }
}
</style>
